import { useNavigate, useParams } from "react-router";

import { Box } from "@/components/layout/flexbox";
import { useAuth } from "@/components/lib/auth";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { ProgramComponentDetails } from "@/components/pages_logged_in/program/components/ProgramComponentDetails";
import { ProgramComponentResponse } from "@/components/pages_logged_in/program/components/ProgramComponentResponse";
import { ProgramDetailsHeader } from "@/components/pages_logged_in/program/components/ProgramDetailsHeader";
import { ProgramDetailsLoader } from "@/components/pages_logged_in/program/components/ProgramDetailsLoader";
import { ProgramSurveys } from "@/components/pages_logged_in/program/components/ProgramSurveys";
import { PROGRAM_TABS_CONFIG } from "@/components/pages_logged_in/program/components/ProgramTabs";
import { ProgramDetails } from "@/components/pages_logged_in/program/components/program-details/ProgramDetails";
import { PermissionErrorPage } from "@/components/pages_public/403";
import { Container } from "@/components/pieces/bootstrap";
import { getRefreshToken } from "@/components/session/JwtTokenManager";
import { SIDE_NAV_WIDTH } from "@/css/constants";
import { useProgramQuery } from "@/graphql";

const PROGRAM_SURVEYS_VIEW = [
  "surveys",
  "action-items",
  "ai-roleplays",
  "videos",
  "articles",
  "announcement",
  "group-meetings",
];

const getComponent = (
  view?: string,
  componentId?: string,
  responseId?: string,
) => {
  if (responseId) {
    return ProgramComponentResponse;
  } else if (componentId) {
    return ProgramComponentDetails;
  } else if (view && PROGRAM_SURVEYS_VIEW.includes(view)) {
    return ProgramSurveys;
  } else {
    return ProgramDetails;
  }
};

function AuthProgramDetails() {
  const { id, componentId, view, responseId } = useParams();
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const { loading, data, error, refetch } = useProgramQuery({
    variables: { programId: id || "" },
    skip: !id,
  });

  if (loading) {
    return <ProgramDetailsLoader includeSidebar={true} />;
  }

  const program = data?.program;

  if (!program || error || !id) {
    return <PermissionErrorPage />;
  }

  const Component = getComponent(view, componentId, responseId);

  if (currentUser && !currentUser.name) {
    const token = getRefreshToken();
    navigate(
      `/activate-participant/${id}/${token}?next=/programs/${id}/details`,
    );
    return null;
  }

  return (
    <Box ml={[0, 0, SIDE_NAV_WIDTH]}>
      <ProgramDetailsHeader
        program={program}
        initialTab={PROGRAM_TABS_CONFIG[1].key}
        refetchProgram={refetch}
      />
      <Container mb={2}>
        <Component
          program={program}
          refetchProgram={refetch}
          view={view || ""}
        />
      </Container>
    </Box>
  );
}

export function ProgramDetailsPage() {
  return (
    <Authenticate maxWidth="100%" layout="full">
      <AuthProgramDetails />
    </Authenticate>
  );
}
